<app-cabecalho-esquerda [data]="data.CABECALHO"></app-cabecalho-esquerda>
<app-solucoes [data]="data.SOLUCOES"></app-solucoes>
<app-exemplos [data]="data.EXEMPLOS"></app-exemplos>